export const STEP_SELECTOR_SIDEBAR_WIDTH = 250;
